module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "sun_rays.e9d538ae.svg";